export default __webpack_public_path__ + "static/media/slides.2095385c.svg";